import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '36',
  height: '36',
  viewBox: '0 0 36 36'
}, [
  h('path', {
    d: 'M18 8.1c2.5 0 5 1 7 2.9 3.9 3.9 3.9 10.1 0 13.9-1.8 1.9-4.4 2.9-7 2.9-2.6 0-5.1-1-7-2.9-3.8-3.8-3.8-10 0-13.9 1.9-1.8 4.4-2.9 7-2.9zm0-7.9C13.3.2 8.8 2.1 5.4 5.4c-6.9 6.9-6.9 18.2 0 25.1 3.3 3.3 7.8 5.2 12.6 5.2 4.7 0 9.2-1.9 12.6-5.2 6.9-6.9 6.9-18.2 0-25.1C27.2 2.1 22.7.2 18 .2z',
    fill: '#eef2f4'
  }),
  h('path', {
    d: 'M8.2 31.7c-1 0-2-.4-2.8-1.2-6.9-6.9-6.9-18.2 0-25.1 1.5-1.5 4-1.5 5.5 0s1.5 4 0 5.5C7 14.8 7 21 10.9 24.9c1.1 1.1 1.5 2.8.9 4.3-.6 1.6-2 2.5-3.6 2.5',
    fill: '#00d998'
  }),
  h('path', {
    d: 'M17.9 35.8c-4.7 0-9.2-1.8-12.5-5.2-1.5-1.5-1.5-4 0-5.6 1.5-1.5 4-1.5 5.6 0 1.8 1.9 4.3 2.9 7 2.9 2.6 0 5.2-1 7-2.9 1-1 2.5-1.4 3.8-1 1.4.4 2.4 1.4 2.8 2.8.4 1.4 0 2.8-1 3.8-3.4 3.3-7.9 5.2-12.7 5.2z',
    fill: '#00d998'
  }),
  h('path', {
    d: 'M11 25c1 1 1.4 2.5 1.1 3.8-.4 1.4-1.4 2.5-2.8 2.8-1.4.4-2.8 0-3.8-1.1C4 29 4 26.5 5.5 25s4-1.5 5.5 0',
    fill: '#18b681'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/pricing-plan-team_edition.es6.js